export {GatewayRpcService} from './gateway.rpc.service'

export interface GatewayReq<T, M> {
  action: M;
  data: T;
  namespace: Namespace;
  version: Version;
}

export interface AccessToken {
  username: string;
  token: string;
}

export enum StatusCode {
  OK = 0,
  Cancelled = 1,
  Unknown = 2,
  InvalidArgument = 3,
  DeadlineExceeded = 4,
  NotFound = 5,
  AlreadyExists = 6,
  PermissionDenied = 7,
  ResourceExhausted = 8,
  FailedPrecondition = 9,
  Aborted = 10,
  OutOfRange = 11,
  Unimplemented = 12,
  Internal = 13,
  Unavailable = 14,
  DataLoss = 15,
  Unauthenticated = 16
}

export enum Version {
  Base = 0.1
}

export enum Namespace {
  Gateway = "service.Gateway",
  Identity = "identity",
  Document = "document",
  Batch = "batch",
  Notification = "notification",
  Queue = "queue"
}

type JSONValue =
  | string
  | number
  | boolean
  | JSONObject
  | JSONArray;

interface JSONObject {
  [x: string]: JSONValue;
}

interface JSONArray extends Array<JSONValue> {
}


